var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c(
        "div",
        { staticClass: "rb-eyewear-protection" },
        [
          _c(
            "div",
            { staticClass: "rb-eyewear-protection__first-row" },
            [
              _c("rb-checkbox", {
                staticClass: "rb-eyewear-protection__checkbox",
                attrs: {
                  id: "eyewearProtectionCheckbox",
                  name: "eyewearProtectionCheckbox",
                  disabled: _vm.isCheckboxDisabled,
                  initialvalue: _vm.checkedOnLandingPage,
                  title: _vm.checkboxTitle,
                  type: "checkbox",
                },
                on: { change: _vm.onToggleCheckbox },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "rb-eyewear-protection__price" }, [
                _vm._v("\n      " + _vm._s(_vm.price) + "\n    "),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "rb-eyewear-protection__links" }, [
            _c(
              "button",
              {
                staticClass: "--details-link",
                on: { click: _vm.onDetailsClick },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("eyewear_protection.links.first")) +
                    "\n    "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.isQuebecLinkVisible
              ? _c(
                  "a",
                  {
                    staticClass: "--quebec-link",
                    attrs: {
                      href: "https://media.ray-ban.com/docs/CST-2405-16-FINAL.pdf",
                      target: "_blank",
                    },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t("eyewear_protection.links.second")) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "rb-eyewear-protection__disclaimer" }, [
            _vm._v(_vm._s(_vm.$t("eyewear_protection.disclaimer"))),
          ]),
          _vm._v(" "),
          _c("rb-eyewear-protection-panel-and-modal", {
            attrs: { "is-visible": _vm.isOverlayVisible },
            on: { closeOverlay: _vm.closeOverlay },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }